import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/youtube/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/youtube/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/youtube/locales/fi/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages);


export class IconYoutube24 extends LitElement {
  render() {
      const title = i18n.t({ message: `YouTube logo`, id: 'icon.title.youtube', comment: 'Title for YouTube icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="24"height="24"fill="none"viewBox="0 0 24 24" part="w-icon-youtube-24-part">${unsafeStatic(`<title>${title}</title>`)}<path fill="currentColor" fill-rule="evenodd" d="M11.749 4c-.994.003-4.796.031-7.451.23-.43.053-1.368.057-2.205.964-.66.69-.874 2.258-.874 2.258S1.017 9.14 1 10.898v2.198c.017 1.759.219 3.446.219 3.446s.214 1.568.874 2.258c.837.907 1.937.878 2.427.973 1.61.16 6.533.218 7.36.227h.41c1.059-.006 4.793-.04 7.411-.236.43-.053 1.368-.057 2.205-.964.66-.69.874-2.258.874-2.258S23 14.7 23 12.86v-1.726c0-1.842-.22-3.682-.22-3.682s-.214-1.568-.874-2.258c-.837-.907-1.775-.91-2.205-.964-2.656-.199-6.457-.227-7.452-.23zM9.727 8.56l5.945 3.208-5.944 3.187z" clip-rule="evenodd"></path></svg>`; }
}
if (!customElements.get('w-icon-youtube-24')) {
  customElements.define('w-icon-youtube-24', IconYoutube24);
}